// @flow
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useIsMobile, useDarkStatusBar } from '@helpers/helpers';
import { useDispatch } from 'react-redux';
import { getUser } from '@context/user';
import { getSubscriptionUserInfo } from '@context/subscription';
import './SubscriptionHeader.scss';

type Props = {
  forceVisibility?: boolean,
};


const SubscriptionHeader = ({ forceVisibility }: Props) => {
  const dispatch = useDispatch();

  const history = useHistory();
  const [isMobile, isIpad] = useIsMobile();
  // Wider screens show the app's dark desktop header instead
  const visible = isMobile || isIpad || !!forceVisibility;

  const handleClose = useCallback(() => {
    history.replace('/ajustes');
    dispatch(getUser());
    dispatch(getSubscriptionUserInfo());
  }, [dispatch, history]);

  useDarkStatusBar(visible);

  if (!visible) return null;

  return (
    <div className="subscriptionHeader">
      <div className="sbcontent">
        <div className="closeBtn" onClick={handleClose}/>
      </div>
      <hr/>
    </div>
  );
};


export default SubscriptionHeader;
